import { createSlice } from "@reduxjs/toolkit";

const infoDialog = createSlice({
  name: "infoDialog",
  initialState: {
      config: {
        show: false,
      },
      queue: [],
  },
  reducers: {
    openInfoDialog: (state, { payload }) => {
      // pass props to the InfoDialog component
      const { onButtonClick, onClose, cancelButtonText,  onCancelClick, dispatch, ...rest } = payload;
      
      const config = {
        onButtonClick: async (...args) => {
          const result = await onButtonClick?.(...args);

          if (result === false) return;
          dispatch(closeInfoDialog());
        },
        onClose: () => {
          onClose?.();
          dispatch(closeInfoDialog());
        },
        onCancelClick: !cancelButtonText
          ? undefined
          : () => {
              onCancelClick?.();
              dispatch(closeInfoDialog());
            },
        cancelButtonText,
        ...rest,
        show: true,
      };


      if (state.config.show) {
        // dialog is already opened, add new dialog to the queue
        state.queue.push(config);
      } else {
        state.config = config;
      }
    },
    closeInfoDialog: (state) => {
      const [nextDialog, ...restQueue] = state.queue;

      if (nextDialog) {
        state.config = nextDialog;
        state.queue = restQueue
        return;
      }

      state.config.show = false;
    },
    reset: (state) => {

      state.config = {
        show: false,
      }
    },
    resetQueue: (state) => {
      state.queue = [];
    },
    updateInfoDialog: (state, { payload }) => {
      state.config = { ...state.config, ...payload }
    }
  },
});

export const {
  closeInfoDialog,
  openInfoDialog,
  updateInfoDialog,
  reset
} = infoDialog.actions;
export const infoDialogActions = infoDialog.actions;
export const infoDialogSelector = (state) => state.infoDialog;
export const infoDialogReducer = infoDialog.reducer;
export default infoDialogReducer;

export const selectIsInfoDialogOpen = (state) => Boolean(state.infoDialog.config?.show);